(function () {
  var scope = document.querySelector(".fw-vip") || document;
  try {
    var nm = new URLSearchParams(window.location.search).get("name");
    if (nm) {
      nm = nm
        .replace(/[^a-zA-Z\u00C0-\u017F' -]/g, "")
        .trim()
        .slice(0, 24);
      if (nm) {
        nm = nm.charAt(0).toUpperCase() + nm.slice(1);
        scope.querySelectorAll("[data-name]").forEach(function (el) {
          el.textContent = nm;
        });
      }
    }
  } catch (e) {}
  var CFG = {};
  try {
    var cfgEl = document.getElementById("fw-vip-diamonds-config");
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent) || {};
  } catch (e2) {}
  // 2 days + 6 hours, stored per browser session so a reload does not reset it.
var SESSION_MS = 24 * 60 * 60 * 1000;
  var STORE_KEY = "fwVipOfferEnds";
  function sessionDeadline() {
    try {
      var stored = parseInt(localStorage.getItem(STORE_KEY) || "", 10);
      if (stored && stored > 0) return stored;
      var end = Date.now() + SESSION_MS;
      sessionStorage.setItem(STORE_KEY, String(end));
      return end;
    } catch (e3) {
      return Date.now() + SESSION_MS;
    }
  }
  var deadline = sessionDeadline();
  function two(n) {
    return (n < 10 ? "0" : "") + n;
  }
  function tick() {
    var diff = Math.max(0, deadline - Date.now());
    var d = Math.floor(diff / 86400000),
      h = Math.floor((diff % 86400000) / 3600000),
      m = Math.floor((diff % 3600000) / 60000),
      s = Math.floor((diff % 60000) / 1000);
    scope.querySelectorAll("[data-countdown]").forEach(function (b) {
      var e;
      if ((e = b.querySelector("[data-d]"))) e.textContent = two(d);
      if ((e = b.querySelector("[data-h]"))) e.textContent = two(h);
      if ((e = b.querySelector("[data-m]"))) e.textContent = two(m);
      if ((e = b.querySelector("[data-s]"))) e.textContent = two(s);
    });
    scope.querySelectorAll("[data-countdown-short]").forEach(function (e) {
      e.textContent = d + "d " + two(h) + ":" + two(m) + ":" + two(s);
    });
  }
  tick();
  setInterval(tick, 1000);
  var q = function (s) {
    return scope.querySelector(s);
  };
  var currentTier = "1",
    currentShape = "Round";
  var PRICES = { 1: 199, 2: 499, 3: 999 };
  var PKGNAMES = { 1: "The Invitation", 2: "The Signature", 3: "The Legacy" };
  // Package + cut maps to the live Shopify variant IDs.
  // Claim uses these in the preview cart. Secure my order uses them at checkout.
  var VARIANTS = CFG.variants && CFG.variants[1] ? CFG.variants : {
    1: { Round: "47599929655452", Oval: "47599944073372", Princess: "47599944106140", Emerald: "47599944138908", Pear: "47599944171676" },
    2: { Round: "47599962030236", Oval: "47599976775836", Princess: "47599976808604", Emerald: "47599976841372", Pear: "47599976874140" },
    3: { Round: "47599962488988", Oval: "47599977529500", Princess: "47599977562268", Emerald: "47599977595036", Pear: "47599977627804" }
  };
  // Left-side photos for every package + cut. Liquid product pickers can override these.
  var IMAGE_FALLBACKS = {
    "47599929655452": "https://cdn.shopify.com/s/files/1/2377/0397/files/05ct-round-diamond.webp",
    "47599944073372": "https://cdn.shopify.com/s/files/1/2377/0397/files/05ct-oval-diamond.webp",
    "47599944106140": "https://cdn.shopify.com/s/files/1/2377/0397/files/05ct-princess-diamond.webp",
    "47599944138908": "https://cdn.shopify.com/s/files/1/2377/0397/files/05ct-emerald-diamond.webp",
    "47599944171676": "https://cdn.shopify.com/s/files/1/2377/0397/files/05ct-pear-diamond.webp",
    "47599962030236": "https://cdn.shopify.com/s/files/1/2377/0397/files/1.5ct-round-diamond.webp",
    "47599976775836": "https://cdn.shopify.com/s/files/1/2377/0397/files/1.5ct-oval-diamond.webp",
    "47599976808604": "https://cdn.shopify.com/s/files/1/2377/0397/files/1.5ct-princess-diamond.webp",
    "47599976841372": "https://cdn.shopify.com/s/files/1/2377/0397/files/1.5ct-emerald-diamond.webp",
    "47599976874140": "https://cdn.shopify.com/s/files/1/2377/0397/files/1.5ct-pear-diamond.webp",
    "47599962488988": "https://cdn.shopify.com/s/files/1/2377/0397/files/3ct-round-diamond.webp",
    "47599977529500": "https://cdn.shopify.com/s/files/1/2377/0397/files/3ct-oval-diamond.webp",
    "47599977562268": "https://cdn.shopify.com/s/files/1/2377/0397/files/3ct-princess-diamond.webp",
    "47599977595036": "https://cdn.shopify.com/s/files/1/2377/0397/files/3ct-emerald-diamond.webp",
    "47599977627804": "https://cdn.shopify.com/s/files/1/2377/0397/files/3ct-pear-diamond.webp"
  };
  CFG.images = Object.assign({}, IMAGE_FALLBACKS, CFG.images || {});
  function ccy(n) {
    return n.toLocaleString("en-US");
  }
  function addonKey(b) {
    return String(b.getAttribute("data-variant") || "").replace(/\D/g, "");
  }
  function addonPrice(b) {
    var card = b.closest(".fw-vip__addon");
    var row = card && card.querySelector("[data-addon-amount]");
    if (row) return parseFloat(row.getAttribute("data-addon-amount")) || 0;
    return parseFloat(b.getAttribute("data-price")) || 0;
  }
  // Unique by variant so the page list and the popup do not double-count.
  function chosenAddons() {
    var seen = {};
    var a = [];
    scope.querySelectorAll("[data-addon].is-added").forEach(function (b) {
      var id = addonKey(b);
      if (!id || seen[id]) return;
      seen[id] = true;
      a.push(b);
    });
    return a;
  }
  function setAddonAdded(id, on) {
    scope.querySelectorAll("[data-addon]").forEach(function (b) {
      if (addonKey(b) !== id) return;
      b.classList.toggle("is-added", on);
      var card = b.closest(".fw-vip__addon");
      if (card) card.classList.toggle("is-added", on);
      b.innerHTML = on ? "Added \u2713" : "\u002B\u00A0 Add to my order";
    });
  }
  // Strip anything that is not a digit so pasted permalinks still work.
  function currentVariantId() {
    var row = VARIANTS[currentTier] || {};
    return String(row[currentShape] || "").replace(/\D/g, "");
  }
  function cartRoot() {
    var root = (CFG.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || "/").toString();
    return root.replace(/\/$/, "") || "";
  }
  // Preview cart only. Nothing is added to Shopify until Secure my order.
  function updateCart() {
    var addons = chosenAddons(),
      total = PRICES[currentTier] || 0;
    addons.forEach(function (b) {
      total += addonPrice(b);
    });
    var it = q("[data-cart-items]"),
      tt = q("[data-cart-total]");
    if (it) {
      var t = PKGNAMES[currentTier] + " \u00B7 " + currentShape;
      if (addons.length) t += " + " + addons.length + " add-on" + (addons.length > 1 ? "s" : "");
      it.textContent = t;
    }
    if (tt) tt.textContent = ccy(total);
    var ct = q("[data-checkout-total]");
    if (ct) ct.textContent = ccy(total);
  }
  // Build the Shopify cart payload. IDs stay strings so they are not rounded.
  function checkoutItems() {
    var items = [];
    var vid = currentVariantId();
    if (vid) items.push({ id: vid, quantity: 1 });
    chosenAddons().forEach(function (b) {
      var id = String(b.getAttribute("data-variant") || "").replace(/\D/g, "");
      if (id) items.push({ id: id, quantity: 1 });
    });
    return items;
  }
  // Discount codes attached to selected add-ons, e.g. VIPSTUDS on the stud earrings.
  function checkoutDiscountCode() {
    var code = "";
    chosenAddons().forEach(function (b) {
      var next = String(b.getAttribute("data-discount") || "").trim();
      if (next && !code) code = next;
    });
    return code;
  }
  function checkoutUrl(code) {
    var root = cartRoot();
    var dest = root + "/checkout";
    if (!code) return dest;
    return root + "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(dest);
  }
  function postCart(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: body ? JSON.stringify(body) : "{}",
    });
  }
  function ingestProduct(p) {
    if (!p) return;
    var fallback = p.featured_image;
    if (fallback && typeof fallback === "object") fallback = fallback.src;
    if (!fallback && p.images && p.images[0]) {
      fallback = typeof p.images[0] === "string" ? p.images[0] : p.images[0].src;
    }
    (p.variants || []).forEach(function (v) {
      var src = v.featured_image && (v.featured_image.src || v.featured_image);
      if (!src) src = fallback;
      if (src) CFG.images[String(v.id)] = src;
    });
  }
  // Swap the left visual to the selected package + cut photo.
  function updateVariantImage() {
    var wrap = q("[data-diamond]");
    var img = q("[data-variant-img]");
    if (!wrap || !img) return;
    var svg = wrap.querySelector(".fw-vip__diamond-svg");
    var src = CFG.images[currentVariantId()] || "";
    var pkg = PKG[currentTier];
    if (!src) {
      wrap.classList.remove("has-photo");
      img.removeAttribute("src");
      img.hidden = true;
      if (svg) svg.hidden = false;
      if (pkg) wrap.style.transform = "scale(" + pkg.diamondScale + ")";
      return;
    }
    wrap.classList.add("has-photo");
    wrap.style.transform = "none";
    img.hidden = false;
    img.alt = (PKGNAMES[currentTier] || "VIP bundle") + " " + currentShape + " diamond";
    if (svg) svg.hidden = true;
    if (img.getAttribute("src") !== src) img.src = src;
  }
  // Theme-editor product picks can replace the CDN fallbacks with live variant photos.
  function hydrateImages() {
    updateVariantImage();
    var handles = (CFG.handles || []).filter(Boolean);
    if (!handles.length) return;
    var root = cartRoot() || "";
    Promise.all(
      handles.map(function (h) {
        return fetch(root + "/products/" + encodeURIComponent(h) + ".js")
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      products.forEach(ingestProduct);
      updateVariantImage();
    });
  }
  // Permalink /cart/ID:1?checkout is blocked on many shops ("Link no longer exists").
  // Clear, add the claimed items through the Ajax Cart API, then go to /checkout.
  function goToCheckout() {
    var items = checkoutItems();
    if (!items.length) {
      console.warn("[ForeverWick] Missing bundle variant ID. Check VIP Diamonds section settings.");
      return;
    }
    var root = cartRoot();
    var buttons = scope.querySelectorAll("[data-checkout]");
    buttons.forEach(function (b) {
      b.disabled = true;
    });
    postCart(root + "/cart/clear.js")
      .catch(function () {
        return null;
      })
      .then(function () {
        return postCart(root + "/cart/add.js", { items: items });
      })
      .then(function (res) {
        if (!res) throw new Error("Could not reach the cart.");
        return res.json().then(function (data) {
          if (!res.ok) {
            var pkg = (PKGNAMES[currentTier] || "This package") + " \u00B7 " + currentShape;
            var msg = (data && (data.description || data.message)) || "This package is not available for checkout yet.";
            if (/cannot find variant/i.test(msg)) {
              msg = pkg + " is not available on the Online Store yet. Publish that VIP product (it can stay hidden from the catalog, like Legacy) and try again.";
            }
            throw new Error(msg);
          }
          window.location.href = checkoutUrl(checkoutDiscountCode());
        });
      })
      .catch(function (err) {
        console.warn("[ForeverWick] Checkout failed", err);
        buttons.forEach(function (b) {
          b.disabled = false;
        });
        window.alert(err && err.message ? err.message : "Could not start checkout. Please try again.");
      });
  }
  scope.querySelectorAll("[data-checkout]").forEach(function (btn) {
    btn.addEventListener("click", goToCheckout);
  });
  var vipcart = q("[data-vipcart]");
  var previewOpen = false;
  // Preview cart stays hidden until Claim. Then it stays up with the selected bundle.
  function onScroll() {
    if (!vipcart) return;
    vipcart.classList.toggle("is-visible", previewOpen);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  var modal = q("[data-modal]");
  // Claim: park the selected bundle in the preview cart, then show add-ons.
  // Add-ons are optional. Zero, one, or more can be added before checkout.
  function setupAddonReadMore() {
    scope.querySelectorAll("[data-addon-desc]").forEach(function (desc) {
      var wrap = desc.closest(".fw-vip__addon-copy");
      var btn = wrap && wrap.querySelector("[data-addon-more]");
      if (!btn || wrap.classList.contains("is-open")) return;
      btn.hidden = desc.scrollHeight <= desc.clientHeight + 2;
    });
  }
  function openModal() {
    if (!modal) return;
    previewOpen = true;
    updateCart();
    if (vipcart) vipcart.classList.add("is-visible");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(setupAddonReadMore);
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  scope.querySelectorAll("[data-open-cart]").forEach(function (b) {
    b.addEventListener("click", openModal);
  });
  scope.querySelectorAll("[data-modal-close]").forEach(function (b) {
    b.addEventListener("click", closeModal);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) closeModal();
  });
  /* Giveaway entries = package price x multiplier (not $1 = 1).
     Invitation 3x199 = 597. Signature 10x499 = 4,990. Legacy 20x999 = 19,980. */
  var PKG = {
    1: {
      name: "The Invitation",
      price: "199",
      was: "Reserved value $349",
      carat: "0.5 ct",
      diamondScale: 0.62,
      url: "PASTE_CHECKOUT_URL_199",
      rows: {
        carat: "0.5 ct",
        igi: false,
        spins: "1",
        entries: "597",
        setting: false,
        jewelry: false,
        vault: "$20",
      },
    },
    2: {
      name: "The Signature",
      price: "499",
      was: "Reserved value $899",
      carat: "1.5 ct",
      diamondScale: 0.82,
      url: "PASTE_CHECKOUT_URL_499",
      rows: {
        carat: "1.5 ct",
        igi: true,
        spins: "2",
        entries: "4,990",
        setting: true,
        jewelry: true,
        vault: "$30",
      },
    },
    3: {
      name: "The Legacy",
      price: "999",
      was: "Reserved value $1,999",
      carat: "3.00 ct",
      diamondScale: 1,
      url: "PASTE_CHECKOUT_URL_999",
      rows: {
        carat: "3.00 ct",
        igi: true,
        spins: "4",
        entries: "19,980",
        setting: true,
        jewelry: true,
        vault: "$80",
      },
    },
  };
  var q = function (s) {
    return scope.querySelector(s);
  };
  var ROW_ORDER = ["carat", "igi", "spins", "entries", "setting", "jewelry", "vault"];
  function orderStack(t) {
    var stack = q("[data-stack]");
    if (!stack) return;
    var items = {};
    stack.querySelectorAll("[data-row]").forEach(function (li) {
      items[li.getAttribute("data-row")] = li;
    });
    var keys = ROW_ORDER.slice();
    if (String(t) === "1") {
      keys.sort(function (a, b) {
        var aOff = items[a] && items[a].classList.contains("is-off") ? 1 : 0;
        var bOff = items[b] && items[b].classList.contains("is-off") ? 1 : 0;
        if (aOff !== bOff) return aOff - bOff;
        return ROW_ORDER.indexOf(a) - ROW_ORDER.indexOf(b);
      });
    }
    keys.forEach(function (k) {
      if (items[k]) stack.appendChild(items[k]);
    });
  }
  function applyTier(t) {
    var p = PKG[t];
    if (!p) return;
    q("[data-carat]").innerHTML = p.carat.replace(" ", "&nbsp;");
    q("[data-carat-row]").textContent = p.rows.carat;
    q("[data-spins]").textContent = p.rows.spins;
    q("[data-spins-plural]").textContent = p.rows.spins === "1" ? "" : "s";
    q("[data-entries]").textContent = p.rows.entries;
    q("[data-vault]").textContent = p.rows.vault;
    var dw = q("[data-diamond]");
    // Keep the real variant photo at full size. Scale the SVG fallback only.
    if (dw && !dw.classList.contains("has-photo")) {
      dw.style.transform = "scale(" + p.diamondScale + ")";
    }
    var map = {
      carat: true,
      igi: p.rows.igi,
      spins: true,
      entries: true,
      setting: p.rows.setting,
      jewelry: p.rows.jewelry,
      vault: true,
    };
    scope.querySelectorAll("[data-row]").forEach(function (li) {
      var on = map[li.getAttribute("data-row")];
      li.classList.toggle("is-on", !!on);
      li.classList.toggle("is-off", !on);
    });
    orderStack(t);
    var r = q("[data-reserve]");
    if (r) {
      var pkg = String(p.name || "").replace(/^The\s+/i, "");
      r.textContent = "Claim the " + pkg + " VIP Bundle";
    }
    var mp = q("[data-modal-pkg]");
    if (mp) mp.textContent = p.name;
    scope.querySelectorAll(".fw-vip__seg-btn").forEach(function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-tier") === String(t));
    });
    currentTier = String(t);
    updateCart();
    updateVariantImage();
  }
  scope.querySelectorAll(".fw-vip__seg-btn").forEach(function (b) {
    b.addEventListener("click", function () {
      applyTier(b.getAttribute("data-tier"));
    });
  });
  applyTier("1");
  hydrateImages();
  var shapes = scope.querySelectorAll(".fw-vip__shape");
  shapes.forEach(function (b) {
    b.addEventListener("click", function () {
      shapes.forEach(function (x) {
        x.classList.remove("is-active");
      });
      b.classList.add("is-active");
      currentShape = b.getAttribute("data-shape");
      var l = q("[data-shape-label]");
      if (l) l.textContent = currentShape;
      updateCart();
      updateVariantImage();
    });
  });
  var addonBtns = scope.querySelectorAll("[data-addon]");
  addonBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      var id = addonKey(b);
      var on = !b.classList.contains("is-added");
      setAddonAdded(id, on);
      updateCart();
    });
  });
  scope.querySelectorAll("[data-addon-more]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var wrap = btn.closest(".fw-vip__addon-copy");
      if (!wrap) return;
      var open = wrap.classList.toggle("is-open");
      btn.textContent = open ? "Read less" : "Read more";
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
  setupAddonReadMore();
  var JEWELS = [
    {
      n: "1.0ct Solitaire Diamond Ring",
      p: "$4,320",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/Four_Prong_Solitaire_Lab_Grown_Diamond_Ring_100_Diamonds_Gold_3.jpg?v=1783453839",
      u: "https://foreverwickcandle.com/products/four-prong-solitaire-diamond-ring-100-diamonds",
    },
    {
      n: "Vivienne Tennis Bracelet",
      p: "$1,880",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/VivienneTennisBraceletGold2.jpg?v=1781179078",
      u: "https://foreverwickcandle.com/products/vivienne-tennis-bracelet",
    },
    {
      n: "Camille Drop Hoop Earrings",
      p: "$1,520",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/CamilleDropHoopEarringsGold2.jpg?v=1781176227",
      u: "https://foreverwickcandle.com/products/camille-drop-hoop-earrings",
    },
    {
      n: "1ct Lab Diamond Pendant",
      p: "$1,500",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/2c4211a87c49cfc2152bccd6bc501222eefe0aa5802f03dd633c287e40c64c08.jpg?v=1779060305",
      u: "https://foreverwickcandle.com/products/1ct-lab-diamond-pendant-w-18-chain-925-sterling-silver",
    },
    {
      n: "0.5ct Solitaire Diamond Ring",
      p: "$2,030",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/Four_Prong_Solitaire_Lab_Grown_Diamond_Ring_50_Diamonds_Gold_3.jpg?v=1783453839",
      u: "https://foreverwickcandle.com/products/four-prong-solitaire-diamond-ring",
    },
    {
      n: "Genevieve Tennis Bracelet",
      p: "$1,780",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/GenevieveTennisBraceletGold2.jpg?v=1781179164",
      u: "https://foreverwickcandle.com/products/genevieve-tennis-bracelet",
    },
    {
      n: "Estelle Bloom Stud Earrings",
      p: "$1,300",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/EstelleBloomStudEarringsGold2.jpg?v=1781176379",
      u: "https://foreverwickcandle.com/products/estelle-bloom-stud-earrings",
    },
    {
      n: "Am\u00E9lie Solitaire Huggies",
      p: "$1,500",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/AmelieSolitaireHuggieEarringsGold2.jpg?v=1781180450",
      u: "https://foreverwickcandle.com/products/amelie-solitaire-huggie-earrings",
    },
    {
      n: "Monroe Pav\u00E9 Tag Necklace",
      p: "$880",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/MonroePaveTagNecklaceGold2.jpg?v=1781179107",
      u: "https://foreverwickcandle.com/products/monroe-pave-tag-necklace",
    },
    {
      n: "Colette Toi et Moi Studs",
      p: "$1,100",
      img: "https://cdn.shopify.com/s/files/1/2377/0397/files/ColetteEmeraldToietMoiStudEarringsGold2.jpg?v=1781151743",
      u: "https://foreverwickcandle.com/products/colette-emerald-toi-et-moi-stud-earrings",
    },
  ];
  var orbit = q("[data-orbit]"),
    track = q("[data-orbit-track]");
  if (orbit && track) {
    var N = JEWELS.length,
      items = [];
    JEWELS.forEach(function (j) {
      var a = document.createElement("a");
      a.className = "fw-vip__orbit-item";
      a.href = j.u;
      a.target = "_blank";
      a.rel = "noopener";
      a.setAttribute("aria-label", j.n + " — " + j.p);
      a.innerHTML =
        '<div class="fw-vip__orbit-card"><img loading="lazy" src="' +
        j.img +
        '" alt="' +
        j.n +
        '"><div class="fw-vip__orbit-name">' +
        j.n +
        '</div><div class="fw-vip__orbit-msrp">' +
        j.p +
        "<small>MSRP value</small></div></div>";
      track.appendChild(a);
      items.push(a);
    });
    var angle = 0,
      Rx = 300,
      Ry = 116,
      dragging = false,
      lastX = 0,
      autov = -0.0045,
      vel = 0;
    function measure() {
      var w = orbit.clientWidth;
      Rx = Math.max(120, w * 0.5 - 88);
      Ry = Math.min(140, Math.max(80, w * 0.16));
    }
    function frame() {
      if (!dragging) ((angle += autov + vel), (vel *= 0.92));
      var step = (Math.PI * 2) / N;
      for (var i = 0; i < N; i++) {
        var t = angle + i * step,
          x = Rx * Math.sin(t),
          depth = Math.cos(t),
          y = Ry * depth,
          sc = 0.5 + 0.5 * ((depth + 1) / 2),
          el = items[i];
        el.style.transform =
          "translate(" + x.toFixed(1) + "px," + y.toFixed(1) + "px) scale(" + sc.toFixed(3) + ")";
        el.style.zIndex = Math.round((depth + 1) * 100);
        el.style.opacity = (0.32 + 0.68 * ((depth + 1) / 2)).toFixed(2);
      }
      requestAnimationFrame(frame);
    }
    measure();
    window.addEventListener("resize", measure);
    requestAnimationFrame(frame);
    function down(x) {
      dragging = true;
      lastX = x;
    }
    function move(x) {
      if (!dragging) return;
      var dx = x - lastX;
      lastX = x;
      angle += dx * 0.006;
      vel = dx * 0.006;
    }
    function up() {
      dragging = false;
    }
    orbit.addEventListener("pointerdown", function (e) {
      down(e.clientX);
    });
    window.addEventListener("pointermove", function (e) {
      move(e.clientX);
    });
    window.addEventListener("pointerup", up);
    items.forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (Math.abs(vel) > 0.02) e.preventDefault();
      });
    });
  }
})();
